import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

class FormFieldPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="general">
        {this.renderGeneralForm()}
      </div>
    )
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row">

          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('field')}</label>
              <div>{this.props.field}</div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('type')}</label>
              <div>{this.props.type}</div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('required')}</label>
              <div>{this.props.required == true ? I18n.t('yes') : I18n.t('no')}</div>
            </div>
          </div>
        
        </div>
      </div>
    )
  }
}

export default FormFieldPresenterGeneral